export default __webpack_public_path__ + "static/2-c0b8ce99ade0d50d5329af85b6953bb7.jpeg";